import React, { useState, memo, useCallback, useMemo } from "react";
import { CargoCargoOperationHeader } from "../../../../constants";
import CargoPortList from "./CargoPortList";

function CargoCargoPortOperations(props) {
  const {
    disableEdit = false,
    calculatorData = [],
    onChangePortOperations = () => {},
    onClickEditCargoContract,
    isContractEstimate,
  } = props;
  const { vesselVoyageData = [] } = calculatorData || {};
  let newPortOperationHeader = [...CargoCargoOperationHeader];

  if (isContractEstimate) {
    newPortOperationHeader.push({
      label: "View Contract",
      width: "120px",
      paddingLeft: "10px",
    });
  }

  let showModal = ["Dist Normal", "Dist ECA", "Terms", "Supply"];
  if (disableEdit) showModal = showModal.filter((item) => item !== "Supply");

  const handleViewContractClick = useCallback(() => {
    if (isContractEstimate && onClickEditCargoContract) {
      onClickEditCargoContract();
    }
  }, [isContractEstimate, onClickEditCargoContract]);

  return (
    <div style={{ overflow: "auto" }} className="operation-background scroll-thin">
      <div className="port-operation-buttons"></div>
      <div className="cargo-cargo-port-operation-header">
        {newPortOperationHeader.map((item, index) => {
          const isModalField = showModal.includes(item.label);
          const isViewContract = item.label === "View Contract";

          return (
            <div
              key={index}
              className="flex items-center"
              style={{
                minWidth: item.width,
                width: item.width,
              }}
            >
              <span
                style={{
                  width: "100%",
                  paddingLeft: item?.paddingLeft,
                  cursor:
                    isModalField || isViewContract ? "pointer" : "default",
                  color: "#ffffff",
                  textDecoration:
                    isModalField || isViewContract ? "underline" : "none",
                  display: "flex",
                  flexDirection: "column",
                }}
                onClick={isViewContract ? handleViewContractClick : undefined}
              >
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
      {vesselVoyageData.length ? (
        <CargoPortList
          onChangePortOperations={onChangePortOperations}
          combinedOperation={vesselVoyageData}
        />
      ) : (
        <div className="no-port-found-div">
          <p>No port operations found.</p>
        </div>
      )}
    </div>
  );
}

export default memo(CargoCargoPortOperations);
